import { render, staticRenderFns } from "./TransactionsSettingsModal.vue?vue&type=template&id=f1a0a768&scoped=true&"
import script from "./TransactionsSettingsModal.vue?vue&type=script&lang=js&"
export * from "./TransactionsSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a0a768",
  null
  
)

export default component.exports